import MoneyInput from '~/components/MoneyInput.jsx';
import ErrorMessage from '~/components/ErrorMessage';

const EditVariablePaymentQuestionForm = ({ settings, setSettings }) => {
    const minAmount = parseFloat(settings?.minAmount) || 0;
    const maxAmount = parseFloat(settings?.maxAmount) || 0;
    const defaultAmount = parseFloat(settings?.defaultAmount) || 0;

    const minError = settings?.minAmount !== undefined && settings?.maxAmount !== undefined && minAmount >= maxAmount
        ? 'Minimum amount must be less than maximum amount.'
        : '';
    const maxError = settings?.maxAmount !== undefined && settings?.minAmount !== undefined && maxAmount <= minAmount
        ? 'Maximum amount must be greater than minimum amount.'
        : '';
    const defaultError = settings?.defaultAmount !== undefined
        ? (defaultAmount < minAmount
            ? 'Default amount must be at least the minimum amount.'
            : defaultAmount > maxAmount && maxAmount > 0
                ? 'Default amount must not exceed the maximum amount.'
                : '')
        : '';

    return (
        <div>
            <MoneyInput
                label="Minimum Amount"
                className="mt-4"
                value={settings?.minAmount ?? ''}
                onChange={value => setSettings({ ...settings, minAmount: value })}
            />
            <div className="text-sm mx-4 mt-1 text-gray-500">
                The minimum amount a client can select.
            </div>
            {!!minError && <ErrorMessage className="mx-4 mt-1">{minError}</ErrorMessage>}

            <MoneyInput
                label="Maximum Amount"
                className="mt-4"
                value={settings?.maxAmount ?? ''}
                onChange={value => setSettings({ ...settings, maxAmount: value })}
            />
            <div className="text-sm mx-4 mt-1 text-gray-500">
                The maximum amount a client can select.
            </div>
            {!!maxError && <ErrorMessage className="mx-4 mt-1">{maxError}</ErrorMessage>}

            <MoneyInput
                label="Default Amount"
                className="mt-4"
                value={settings?.defaultAmount ?? ''}
                onChange={value => setSettings({ ...settings, defaultAmount: value })}
            />
            <div className="text-sm mx-4 mt-1 text-gray-500">
                The amount the slider will start at.
            </div>
            {!!defaultError && <ErrorMessage className="mx-4 mt-1">{defaultError}</ErrorMessage>}
        </div>
    );
};

export default EditVariablePaymentQuestionForm;

